import type { EmojiPluginOptions } from '@atlaskit/editor-plugin-emoji/emojiPluginType';
import type { EmojiProvider } from '@atlaskit/emoji/types';

interface Props {
	options: never;
	providers: {
		emojiProvider: Promise<EmojiProvider> | undefined;
	};
}

export function emojiPluginOptions({ providers }: Props): EmojiPluginOptions {
	return {
		emojiProvider: providers.emojiProvider,
	};
}
